import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _SlimBox from "SlimBox.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/slim_box.js?styleId=SlimBox";

const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'

const SlimBox = /*#__PURE__*/styled('div', null, {
  displayName: "SlimBox",
  styles: _SlimBox,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp')
  })
})

export default SlimBox
